import { AlpineComponent } from 'alpinejs';

const FeeCalculator = (): AlpineComponent => ({
  salary: null,
  fee: 0,
  hasResult: false,
  hasError: false,
  calculateFee(e: SubmitEvent) {
    e.preventDefault();

    if (!this.salary || this.salary.replace(/\D/g, '').length === 0) {
      this.hasError = true;
      return;
    }

    const salary = Number(this.salary.replace(/\D/g, ''));

    const tiers = [
      { threshold: 2500000, baseFee: 515, rate: 0 },
      { threshold: 4000000, baseFee: 515, rate: 0.0103 },
      { threshold: 7700000, baseFee: 669.5, rate: 0.007828 },
      { threshold: 13000000, baseFee: 958.93, rate: 0.004223 },
      { threshold: 20000000, baseFee: 1182.44, rate: 0.002987 },
      { threshold: 36000000, baseFee: 1391.53, rate: 0.002472 },
      { threshold: 56000000, baseFee: 1787.05, rate: 0.001854 },
      { threshold: 77000000, baseFee: 2157.85, rate: 0.001442 },
      { threshold: 100000000, baseFee: 2460.67, rate: 0.001236 },
      { threshold: 140000000, baseFee: 2744.95, rate: 0.000824 },
      { threshold: 510000000, baseFee: 3074.55, rate: 0.000515 },
      { threshold: 4100000000, baseFee: 4980.05, rate: 0.0002163 },
      { threshold: Infinity, baseFee: 12745.22, rate: 0.0001236 }
    ];

    let fee = 0;
    let prevThreshold = 2500000;
    for (const { threshold, baseFee, rate } of tiers) {
      if (salary <= threshold) {
        fee = baseFee + (rate * (salary - prevThreshold)) / 100;
        break;
      } else {
        prevThreshold = threshold;
      }
    }

    this.fee = Math.round(fee).toLocaleString('de-DE');
    this.hasResult = true;
  },
  reset() {
    this.salary = null;
    this.hasResult = false;

    setTimeout(() => this.$refs.input.focus(), 10);
  },
  updateValue() {
    this.hasError = false;

    if (!this.salary) return;
    this.salary = Number(this.salary.replace(/\D/g, '')).toLocaleString();
  }
});

export default FeeCalculator;
